<script>
import ActionBar from '@/components/core/ActionBar.vue';

export default {
  extends: ActionBar,
  data() {
    return {
      resourceName: 'User',
      urlFragment: 'users',
    };
  },
};
</script>

<style></style>
